import { ViewBasic } from '@quatrecentquatre/manage-me';
import lightGallery from 'lightgallery/lightgallery.min';
import lgZoom from 'lightgallery/plugins/zoom/lg-zoom.min';
import "lightgallery/scss/lightgallery-bundle.scss";

export class ParksMapImage extends ViewBasic {
    constructor(options) {
        super(options);

        this.imageContent = this.el.querySelector('.image-content');
        this.image = this.imageContent ? this.imageContent.querySelector('img') : null;
        this.openGallery = this.openGallery.bind(this);
    }

    initialize() {
        if (!this.image) {
            return;
        }

        // Initialise lightgallery sur le conteneur de l'image
        this.lightGallery = lightGallery(this.imageContent, {
            dynamic: true,
            zoom: true,
            mode: 'lg-fade',
            showZoomInOutIcons: true,
            speed: 350,
            plugins: [lgZoom],
            licenseKey: process.env.LIGHTGALLERY_LICENSE_KEY ?? '',
            mobileSettings: {
                controls: true,
                showCloseIcon: true,
                download: false
            },
            download: false,
            actualSize: false,
            hideScrollbar: true,
            counter: false,
            dynamicEl: [{
                src: this.image.src,
                thumb: this.image.src,
                alt: this.image.alt || ''
            }]
        });

        this.addEvents();
    }

    addEvents() {
        if (this.imageContent) {
            this.imageContent.addEventListener('click', this.openGallery);
        }
    }

    removeEvents() {
        if (this.imageContent) {
            this.imageContent.removeEventListener('click', this.openGallery);
        }
    }

    openGallery() {
        if (this.lightGallery) {
            this.lightGallery.openGallery(0);
        }
    }
}

Me.views['ParksMapImage'] = ParksMapImage;
